"use client";

import React from "react";
import {AccountVerifiedNotification} from "@/components/notifications/types/AccountVerifiedNotification";
import {ExportNotification} from "@/components/notifications/types/ExportNotification";
import {TextNotification} from "@/components/notifications/types/TextNotification";
import type {NotificationDictionary} from "@/components/notifications/NotificationDrawer";
import type {Locale} from "@/i18n-config";
import type {AccountNotification} from "@/utils/notifications/account/types";

export function NotificationView({
    notification,
    locale,
    dictionary,
    onMarkRead,
    onInternalNavigate,
}: {
    notification: AccountNotification;
    locale: Locale;
    dictionary: NotificationDictionary;
    onMarkRead: (notificationId: string) => void | Promise<void>;
    onInternalNavigate: () => void;
}) {
    switch (notification.type) {
        case "account_verified":
            return (
                <AccountVerifiedNotification
                    notification={notification}
                    locale={locale}
                    dictionary={dictionary}
                    onMarkRead={onMarkRead}
                    onInternalNavigate={onInternalNavigate}
                />
            );
        case "export_started":
            return (
                <ExportNotification
                    notification={notification}
                    locale={locale}
                    dictionary={dictionary}
                    onMarkRead={onMarkRead}
                />
            );
        case "export_ready":
            return (
                <ExportNotification
                    notification={notification}
                    locale={locale}
                    dictionary={dictionary}
                    onMarkRead={onMarkRead}
                />
            );
        case "release_note":
            return (
                <TextNotification
                    notification={notification}
                    locale={locale}
                    dictionary={dictionary}
                    onMarkRead={onMarkRead}
                    onInternalNavigate={onInternalNavigate}
                />
            );
        case "text":
            return (
                <TextNotification
                    notification={notification}
                    locale={locale}
                    dictionary={dictionary}
                    onMarkRead={onMarkRead}
                    onInternalNavigate={onInternalNavigate}
                />
            );
    }
}
